<template>
  <div
    class="tm-calendar-body"
    :class="{
      'tm-calendar-body--with-scroll': !hideScroll,
    }"
  >
    <tm-scrollbar
      class="tm-calendar-body__scroll"
      :inactive="hideScroll"
    >
      <div
        ref="rowsElement"
        class="tm-calendar-body__rows"
      >
        <slot />
      </div>
    </tm-scrollbar>
  </div>
</template>

<script setup lang="ts">
import { ref, useResizeObserver } from '@/composition/vue/compositionApi'
import TmScrollbar from '@/components/shared/TmScrollbar.vue'
import { useCalendarInnerScroll } from '@/composition/calendar/calendarScroll'
import TmLogicError from '@/core/error/tmLogicError'

export interface TmCalendarBodyChangeContentSizeParams {
  width: number
}

const props = defineProps<{
  onChangeContentSize?: (params: TmCalendarBodyChangeContentSizeParams) => void
}>()

const { hideScroll } = useCalendarInnerScroll()

const rowsElement = ref<HTMLDivElement>()

if (props.onChangeContentSize) {
  useResizeObserver(rowsElement, () => {
    if (!props.onChangeContentSize) {
      return
    }
    if (!rowsElement.value) {
      throw new TmLogicError('rowsElement not found')
    }
    const rect = rowsElement.value.getBoundingClientRect()
    props.onChangeContentSize({
      width: rect.width,
    })
  })
}
</script>

<style lang="scss" scoped>
$calendar-border: 1px solid $gray2;

.tm-calendar-body {
  position: relative;
  height: 100%;

  &--with-scroll &__scroll {
    position: absolute;
    inset: 0;
  }

  &__rows {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: stretch;
  }

  :deep(.tm-calendar-row:last-child > *) {
    border-bottom: none;
  }
}
</style>
